import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import InspectionPlanFilter from './inspectionplan-filter';
import InspectionPlanTable from './inspectionplan-table';
import InspectionPlanTile from './inspectionplan-tile';
import InspectionPlanSearch from './inspectionplan-search';
import { selectInspectionPlanFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const InspectionPlanContent = props => {
  const isFilterVisible = useSelector(selectInspectionPlanFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <InspectionPlanSearch />
        </div>
        {isFilterVisible && <InspectionPlanFilter />}

        {!showTileView ? <InspectionPlanTable /> : <InspectionPlanTile />}
      </div>
    </div>
  );
};

export default InspectionPlanContent;
